<template>
  <div class="hidden">현재의 화면을 종료 합니다.</div>
</template>

<script>
export default {
  name: 'PaymentClose',
  created() {
    window.location.replace(`${this.$baeminActionDeepLinkProtocol}closeWebview`)
  }
}
</script>

<style scoped>
.hidden {
  color: white;
}
</style>
